"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accordionContent = exports.accordionTrigger = exports.accordionPanel = exports.accordion = void 0;
const tv_1 = require("../utils/tv");
exports.accordion = (0, tv_1.tv)({
  base: `flex w-full flex-col gap-4`,
  variants: {
    disabled: {
      true: 'pointer-events-none opacity-60'
    }
  },
  defaultVariants: {
    disabled: false
  }
});
exports.accordionPanel = (0, tv_1.tv)({
  base: `
    group bg-primary transition
    hover:bg-support-soft-hover
    active:bg-support-soft-active
    [&:has([sparkAccordionTrigger]:focus-visible)]:border-md
    [&:has([sparkAccordionTrigger]:focus-visible)]:border-keyboard-focus
    [&:has([sparkAccordionTrigger]:focus-visible)]:bg-support-soft-active
  `,
  variants: {
    rounded: {
      true: `rounded-sm`,
      false: ``
    },
    bordered: {
      true: `border-md border-primary`,
      false: `border-none`
    }
  },
  defaultVariants: {
    rounded: false,
    bordered: true
  }
});
exports.accordionTrigger = (0, tv_1.tv)({
  base: `
    flex w-full items-center justify-between gap-4 px-lg py-3 text-left text-xl
    text-primary outline-none
    placeholder:text-secondary
  `
});
exports.accordionContent = (0, tv_1.tv)({
  base: `
    box-border overflow-hidden rounded-b-sm bg-secondary text-sm
    transition-[height] duration-300 ease-in-out
  `
});
